/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
*
* NVIDIA CORPORATION and its licensors retain all intellectual property
* and proprietary rights in and to this software, related documentation
* and any modifications thereto.  Any use, reproduction, disclosure or
* distribution of this software and related documentation without an express
* license agreement from NVIDIA CORPORATION is strictly prohibited.
*/

/** This file was automatically generated. DO NOT MODIFY IT BY HAND. */

/* eslint-disable @typescript-eslint/naming-convention */

import { BridgeCommands } from '../../../src/bridge.commands';

import { Types } from '../../types/index';

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetCaptureSupported: BridgeCommands.Command<
    Types.Share.Shareserver.SetCaptureSupportedParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'SetCaptureSupported',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const RegisterHotkeyNotifications: BridgeCommands.Command<
    {},
    Types.Share.Shareserver.RegisterHotkeyNotificationsReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'RegisterHotkeyNotifications',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const RegisterGeneralNotifications: BridgeCommands.Command<
    {},
    Types.Share.Shareserver.RegisterGeneralNotificationsReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'RegisterGeneralNotifications',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetTelemtryInfoToShadowPlay: BridgeCommands.Command<
    Types.Share.Shareserver.SetTelemtryInfoToShadowPlayParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'SetTelemtryInfoToShadowPlay',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const RegisterCaptureStateChangeNotifications: BridgeCommands.Command<
    {},
    Types.Share.Shareserver.RegisterCaptureStateChangeNotificationsReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'RegisterCaptureStateChangeNotifications',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const RegisterWindowStateChangeNotifications: BridgeCommands.Command<
    {},
    Types.Share.Shareserver.RegisterWindowStateChangeNotificationsReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'RegisterWindowStateChangeNotifications',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const RegisterBroadcastSessionNotifications: BridgeCommands.Command<
    {},
    Types.Share.Shareserver.RegisterBroadcastSessionNotificationsReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'RegisterBroadcastSessionNotifications',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const CaptureSavedNotification: BridgeCommands.Command<
    Types.Share.Shareserver.CaptureSavedNotificationParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'CaptureSavedNotification',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const HighlightSavedNotification: BridgeCommands.Command<
    Types.Share.Shareserver.HighlightSavedNotificationParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'HighlightSavedNotification',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const HighlightCaptureFailureNotification: BridgeCommands.Command<
    Types.Share.Shareserver.HighlightCaptureFailureNotificationParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'HighlightCaptureFailureNotification',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const RegisterSDKNotifications: BridgeCommands.Command<
    {},
    Types.Share.Shareserver.RegisterSDKNotificationsReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'RegisterSDKNotifications',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const RegisterAppNotifications: BridgeCommands.Command<
    {},
    Types.Share.Shareserver.RegisterAppNotificationsReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'RegisterAppNotifications',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetInitData: BridgeCommands.Command<
    {},
    Types.Share.Shareserver.GetInitDataReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'GetInitData',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetMainView: BridgeCommands.Command<
    Types.Share.Shareserver.GetMainViewParameters,
    Types.Share.Shareserver.GetMainViewReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'GetMainView',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const OpenOsc: BridgeCommands.Command<
    Types.Share.Shareserver.OpenOscParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'OpenOsc',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const Launch: BridgeCommands.Command<
    Types.Share.Shareserver.LaunchParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'Launch',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetOverlayReady: BridgeCommands.Command<
    Types.Share.Shareserver.SetOverlayReadyParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'SetOverlayReady',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetShadowPlaySupported: BridgeCommands.Command<
    Types.Share.Shareserver.GetShadowPlaySupportedParameters,
    Types.Share.Shareserver.GetShadowPlaySupportedReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'GetShadowPlaySupported',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetShadowPlayStatus: BridgeCommands.Command<
    {},
    Types.Share.Shareserver.GetShadowPlayStatusReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'GetShadowPlayStatus',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const Get4KSupport: BridgeCommands.Command<
    {},
    Types.Share.Shareserver.Get4KSupportReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'Get4KSupport',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetSupportedBitrates: BridgeCommands.Command<
    Types.Share.Shareserver.GetSupportedBitratesParameters,
    Types.Share.Shareserver.GetSupportedBitratesReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'GetSupportedBitrates',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetSupportedBitratesFramerates: BridgeCommands.Command<
    Types.Share.Shareserver.GetSupportedBitratesFrameratesParameters,
    Types.Share.Shareserver.GetSupportedBitratesFrameratesReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'GetSupportedBitratesFramerates',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetSupportedResolutions: BridgeCommands.Command<
    {},
    Types.Share.Shareserver.GetSupportedResolutionsReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'GetSupportedResolutions',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetSupportedResolutionsCodecs: BridgeCommands.Command<
    {},
    Types.Share.Shareserver.GetSupportedResolutionsCodecsReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'GetSupportedResolutionsCodecs',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetSupportedFramerates: BridgeCommands.Command<
    {},
    Types.Share.Shareserver.GetSupportedFrameratesReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'GetSupportedFramerates',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetQualityDefaultData: BridgeCommands.Command<
    Types.Share.Shareserver.GetQualityDefaultDataParameters,
    Types.Share.Shareserver.GetQualityDefaultDataReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'GetQualityDefaultData',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetCaptureState: BridgeCommands.Command<
    {},
    Types.Share.Shareserver.GetCaptureStateReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'GetCaptureState',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetCaptureProcessInfo: BridgeCommands.Command<
    Types.Share.Shareserver.GetCaptureProcessInfoParameters,
    Types.Share.Shareserver.GetCaptureProcessInfoReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'GetCaptureProcessInfo',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetCaptureControlPIDMode: BridgeCommands.Command<
    {},
    Types.Share.Shareserver.GetCaptureControlPIDModeReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'GetCaptureControlPIDMode',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetScreenshotSupport: BridgeCommands.Command<
    {},
    Types.Share.Shareserver.GetScreenshotSupportReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'GetScreenshotSupport',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const CaptureScreenshot: BridgeCommands.Command<
    {},
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'CaptureScreenshot',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const CaptureCustomScreenshot: BridgeCommands.Command<
    Types.Share.Shareserver.CaptureCustomScreenshotParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'CaptureCustomScreenshot',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const CustomScreenshotNotifications: BridgeCommands.Command<
    {},
    Types.Share.Shareserver.CustomScreenshotNotificationsReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'CustomScreenshotNotifications',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetFreestylePreviewBasePath: BridgeCommands.Command<
    {},
    Types.Share.Shareserver.GetFreestylePreviewBasePathReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'GetFreestylePreviewBasePath',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const StartDiskCapture: BridgeCommands.Command<
    Types.Share.Shareserver.StartDiskCaptureParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'StartDiskCapture',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const StopAndSaveDiskCapture: BridgeCommands.Command<
    Types.Share.Shareserver.StopAndSaveDiskCaptureParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'StopAndSaveDiskCapture',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const StartBufferedCapture: BridgeCommands.Command<
    Types.Share.Shareserver.StartBufferedCaptureParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'StartBufferedCapture',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const StopBufferedCapture: BridgeCommands.Command<
    Types.Share.Shareserver.StopBufferedCaptureParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'StopBufferedCapture',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SaveBufferedCaptureClip: BridgeCommands.Command<
    Types.Share.Shareserver.SaveBufferedCaptureClipParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'SaveBufferedCaptureClip',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const EDGEEvent: BridgeCommands.Command<
    Types.Share.Shareserver.EDGEEventParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'EDGEEvent',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetInstantReplayEnableStatus: BridgeCommands.Command<
    {},
    Types.Share.Shareserver.GetInstantReplayEnableStatusReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'GetInstantReplayEnableStatus',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetInstantReplayRunningStatus: BridgeCommands.Command<
    {},
    Types.Share.Shareserver.GetInstantReplayRunningStatusReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'GetInstantReplayRunningStatus',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetInstantReplaySettings: BridgeCommands.Command<
    {},
    Types.Share.Shareserver.GetInstantReplaySettingsReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'GetInstantReplaySettings',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetInstantReplaySettings: BridgeCommands.Command<
    Types.Share.Shareserver.SetInstantReplaySettingsParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'SetInstantReplaySettings',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const EnableInstantReplay: BridgeCommands.Command<
    Types.Share.Shareserver.EnableInstantReplayParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'EnableInstantReplay',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SaveInstantReplay: BridgeCommands.Command<
    {},
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'SaveInstantReplay',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetLastInstantReplayLength: BridgeCommands.Command<
    {},
    Types.Share.Shareserver.GetLastInstantReplayLengthReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'GetLastInstantReplayLength',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetInstantReplayCustomizeData: BridgeCommands.Command<
    Types.Share.Shareserver.GetInstantReplayCustomizeDataParameters,
    Types.Share.Shareserver.GetInstantReplayCustomizeDataReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'GetInstantReplayCustomizeData',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetRecordEnableStatus: BridgeCommands.Command<
    {},
    Types.Share.Shareserver.GetRecordEnableStatusReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'GetRecordEnableStatus',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetRecordRunningStatus: BridgeCommands.Command<
    {},
    Types.Share.Shareserver.GetRecordRunningStatusReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'GetRecordRunningStatus',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const EnableRecord: BridgeCommands.Command<
    Types.Share.Shareserver.EnableRecordParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'EnableRecord',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetRecordSettings: BridgeCommands.Command<
    {},
    Types.Share.Shareserver.GetRecordSettingsReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'GetRecordSettings',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetRecordSettings: BridgeCommands.Command<
    Types.Share.Shareserver.SetRecordSettingsParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'SetRecordSettings',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetRecordCustomizeData: BridgeCommands.Command<
    Types.Share.Shareserver.GetRecordCustomizeDataParameters,
    Types.Share.Shareserver.GetRecordCustomizeDataReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'GetRecordCustomizeData',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const EnableBroadcast: BridgeCommands.Command<
    Types.Share.Shareserver.EnableBroadcastParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'EnableBroadcast',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const PauseBroadcast: BridgeCommands.Command<
    Types.Share.Shareserver.PauseBroadcastParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'PauseBroadcast',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetBroadcastEnableStatus: BridgeCommands.Command<
    {},
    Types.Share.Shareserver.GetBroadcastEnableStatusReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'GetBroadcastEnableStatus',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetBroadcastRunningStatus: BridgeCommands.Command<
    {},
    Types.Share.Shareserver.GetBroadcastRunningStatusReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'GetBroadcastRunningStatus',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetBroadcastSupported: BridgeCommands.Command<
    {},
    Types.Share.Shareserver.GetBroadcastSupportedReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'GetBroadcastSupported',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetBroadcastSettings: BridgeCommands.Command<
    {},
    Types.Share.Shareserver.GetBroadcastSettingsReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'GetBroadcastSettings',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetBroadcastSettings: BridgeCommands.Command<
    Types.Share.Shareserver.SetBroadcastSettingsParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'SetBroadcastSettings',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetBroadcastSession: BridgeCommands.Command<
    Types.Share.Shareserver.SetBroadcastSessionParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'SetBroadcastSession',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetBroadcastPreferredProviderSetting: BridgeCommands.Command<
    {},
    Types.Share.Shareserver.GetBroadcastPreferredProviderSettingReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'GetBroadcastPreferredProviderSetting',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetBroadcastPreferredProviderSetting: BridgeCommands.Command<
    Types.Share.Shareserver.SetBroadcastPreferredProviderSettingParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'SetBroadcastPreferredProviderSetting',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetBroadcastLastProvider: BridgeCommands.Command<
    {},
    Types.Share.Shareserver.GetBroadcastLastProviderReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'GetBroadcastLastProvider',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetBroadcastLastProvider: BridgeCommands.Command<
    Types.Share.Shareserver.SetBroadcastLastProviderParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'SetBroadcastLastProvider',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetBroadcastTitle: BridgeCommands.Command<
    {},
    Types.Share.Shareserver.GetBroadcastTitleReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'GetBroadcastTitle',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetBroadcast2K: BridgeCommands.Command<
    {},
    Types.Share.Shareserver.GetBroadcast2KReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'GetBroadcast2K',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetBroadcastFacebookLiveSupport: BridgeCommands.Command<
    {},
    Types.Share.Shareserver.GetBroadcastFacebookLiveSupportReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'GetBroadcastFacebookLiveSupport',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetBroadcastIngestServer: BridgeCommands.Command<
    {},
    Types.Share.Shareserver.GetBroadcastIngestServerReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'GetBroadcastIngestServer',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetBroadcastIngestServer: BridgeCommands.Command<
    Types.Share.Shareserver.SetBroadcastIngestServerParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'SetBroadcastIngestServer',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetBroadcastViewerCountImage: BridgeCommands.Command<
    Types.Share.Shareserver.SetBroadcastViewerCountImageParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'SetBroadcastViewerCountImage',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetBroadcastViewerMax: BridgeCommands.Command<
    Types.Share.Shareserver.SetBroadcastViewerMaxParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'SetBroadcastViewerMax',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetRecordBroadcastConcurrencySupport: BridgeCommands.Command<
    {},
    Types.Share.Shareserver.GetRecordBroadcastConcurrencySupportReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'GetRecordBroadcastConcurrencySupport',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetRecordGamestreamConcurrencySupport: BridgeCommands.Command<
    {},
    Types.Share.Shareserver.GetRecordGamestreamConcurrencySupportReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'GetRecordGamestreamConcurrencySupport',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetDesktopCaptureEnabled: BridgeCommands.Command<
    {},
    Types.Share.Shareserver.GetDesktopCaptureEnabledReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'GetDesktopCaptureEnabled',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetDesktopCaptureEnabled: BridgeCommands.Command<
    Types.Share.Shareserver.SetDesktopCaptureEnabledParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'SetDesktopCaptureEnabled',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetDesktopCaptureSupported: BridgeCommands.Command<
    {},
    Types.Share.Shareserver.GetDesktopCaptureSupportedReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'GetDesktopCaptureSupported',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetDesktopCaptureSupportReason: BridgeCommands.Command<
    {},
    Types.Share.Shareserver.GetDesktopCaptureSupportReasonReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'GetDesktopCaptureSupportReason',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetHevcSupportedState: BridgeCommands.Command<
    {},
    Types.Share.Shareserver.GetHevcSupportedStateReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'GetHevcSupportedState',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetAudioMode: BridgeCommands.Command<
    {},
    Types.Share.Shareserver.GetAudioModeReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'GetAudioMode',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetAudioMode: BridgeCommands.Command<
    Types.Share.Shareserver.SetAudioModeParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'SetAudioMode',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetAudioSettings: BridgeCommands.Command<
    {},
    Types.Share.Shareserver.GetAudioSettingsReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'GetAudioSettings',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetAudioSettings: BridgeCommands.Command<
    Types.Share.Shareserver.SetAudioSettingsParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'SetAudioSettings',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetMicCount: BridgeCommands.Command<
    {},
    Types.Share.Shareserver.GetMicCountReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'GetMicCount',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetMicMode: BridgeCommands.Command<
    {},
    Types.Share.Shareserver.GetMicModeReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'GetMicMode',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetMicMode: BridgeCommands.Command<
    Types.Share.Shareserver.SetMicModeParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'SetMicMode',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetMicSettings: BridgeCommands.Command<
    Types.Share.Shareserver.GetMicSettingsParameters,
    Types.Share.Shareserver.GetMicSettingsReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'GetMicSettings',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetMicSettings: BridgeCommands.Command<
    Types.Share.Shareserver.SetMicSettingsParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'SetMicSettings',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const MicPTTMode: BridgeCommands.Command<
    Types.Share.Shareserver.MicPTTModeParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'MicPTTMode',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const EnableWebcam: BridgeCommands.Command<
    Types.Share.Shareserver.EnableWebcamParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'EnableWebcam',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const ToggleWebcam: BridgeCommands.Command<
    {},
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'ToggleWebcam',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetWebcamEnable: BridgeCommands.Command<
    {},
    Types.Share.Shareserver.GetWebcamEnableReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'GetWebcamEnable',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetWebcamShown: BridgeCommands.Command<
    {},
    Types.Share.Shareserver.GetWebcamShownReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'GetWebcamShown',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetWebcamPresent: BridgeCommands.Command<
    {},
    Types.Share.Shareserver.GetWebcamPresentReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'GetWebcamPresent',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetWebcamPreviewState: BridgeCommands.Command<
    {},
    Types.Share.Shareserver.GetWebcamPreviewStateReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'GetWebcamPreviewState',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const EnableWebcamPreview: BridgeCommands.Command<
    Types.Share.Shareserver.EnableWebcamPreviewParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'EnableWebcamPreview',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetHighlightsActive: BridgeCommands.Command<
    {},
    Types.Share.Shareserver.GetHighlightsActiveReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'GetHighlightsActive',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetHighlightsEnable: BridgeCommands.Command<
    {},
    Types.Share.Shareserver.GetHighlightsEnableReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'GetHighlightsEnable',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetHighlightsEnable: BridgeCommands.Command<
    Types.Share.Shareserver.SetHighlightsEnableParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'SetHighlightsEnable',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetSDKInstanceActive: BridgeCommands.Command<
    {},
    Types.Share.Shareserver.GetSDKInstanceActiveReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'GetSDKInstanceActive',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetSDKPermissions: BridgeCommands.Command<
    Types.Share.Shareserver.GetSDKPermissionsParameters,
    Types.Share.Shareserver.GetSDKPermissionsReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'GetSDKPermissions',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetSDKPermissions: BridgeCommands.Command<
    Types.Share.Shareserver.SetSDKPermissionsParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'SetSDKPermissions',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const NotifyAppOverlayState: BridgeCommands.Command<
    Types.Share.Shareserver.NotifyAppOverlayStateParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'NotifyAppOverlayState',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetHighlightsConfig: BridgeCommands.Command<
    Types.Share.Shareserver.GetHighlightsConfigParameters,
    Types.Share.Shareserver.GetHighlightsConfigReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'GetHighlightsConfig',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetHighlightsConfig: BridgeCommands.Command<
    Types.Share.Shareserver.SetHighlightsConfigParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'SetHighlightsConfig',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetApplicationConfigs: BridgeCommands.Command<
    {},
    Types.Share.Shareserver.GetApplicationConfigsReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'GetApplicationConfigs',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetHotkeyShortcut: BridgeCommands.Command<
    Types.Share.Shareserver.GetHotkeyShortcutParameters,
    Types.Share.Shareserver.GetHotkeyShortcutReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'GetHotkeyShortcut',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetHotkeyShortcut: BridgeCommands.Command<
    Types.Share.Shareserver.SetHotkeyShortcutParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'SetHotkeyShortcut',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const ResetHotkeysToDefault: BridgeCommands.Command<
    {},
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'ResetHotkeysToDefault',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetHotkeyMonitoring: BridgeCommands.Command<
    {},
    Types.Share.Shareserver.GetHotkeyMonitoringReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'GetHotkeyMonitoring',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const Init: BridgeCommands.Command<
    Types.Share.Shareserver.InitParameters,
    Types.Share.Shareserver.InitReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'Init',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetHotkeyMonitoring: BridgeCommands.Command<
    Types.Share.Shareserver.SetHotkeyMonitoringParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'SetHotkeyMonitoring',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetHotkeyDynamicEnable: BridgeCommands.Command<
    Types.Share.Shareserver.SetHotkeyDynamicEnableParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'SetHotkeyDynamicEnable',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetIndicatorSupported: BridgeCommands.Command<
    Types.Share.Shareserver.GetIndicatorSupportedParameters,
    Types.Share.Shareserver.GetIndicatorSupportedReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'GetIndicatorSupported',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetIndicatorOverlaySettings: BridgeCommands.Command<
    Types.Share.Shareserver.GetIndicatorOverlaySettingsParameters,
    Types.Share.Shareserver.GetIndicatorOverlaySettingsReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'GetIndicatorOverlaySettings',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetIndicatorOverlaySettings: BridgeCommands.Command<
    Types.Share.Shareserver.SetIndicatorOverlaySettingsParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'SetIndicatorOverlaySettings',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetCustomOverlayDefaultPath: BridgeCommands.Command<
    {},
    Types.Share.Shareserver.GetCustomOverlayDefaultPathReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'GetCustomOverlayDefaultPath',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetCustomOverlaySupport: BridgeCommands.Command<
    {},
    Types.Share.Shareserver.GetCustomOverlaySupportReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'GetCustomOverlaySupport',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetCustomOverlayPath: BridgeCommands.Command<
    Types.Share.Shareserver.GetCustomOverlayPathParameters,
    Types.Share.Shareserver.GetCustomOverlayPathReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'GetCustomOverlayPath',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetCustomOverlayPath: BridgeCommands.Command<
    Types.Share.Shareserver.SetCustomOverlayPathParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'SetCustomOverlayPath',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetCustomOverlayEnable: BridgeCommands.Command<
    Types.Share.Shareserver.GetCustomOverlayEnableParameters,
    Types.Share.Shareserver.GetCustomOverlayEnableReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'GetCustomOverlayEnable',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetCustomOverlayEnable: BridgeCommands.Command<
    Types.Share.Shareserver.SetCustomOverlayEnableParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'SetCustomOverlayEnable',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetCustomOverlayDisplay: BridgeCommands.Command<
    Types.Share.Shareserver.GetCustomOverlayDisplayParameters,
    Types.Share.Shareserver.GetCustomOverlayDisplayReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'GetCustomOverlayDisplay',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SelectCustomOverlay: BridgeCommands.Command<
    Types.Share.Shareserver.SelectCustomOverlayParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'SelectCustomOverlay',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const EnableCustomOverlay: BridgeCommands.Command<
    Types.Share.Shareserver.EnableCustomOverlayParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'EnableCustomOverlay',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetNvCameraToggleState: BridgeCommands.Command<
    {},
    Types.Share.Shareserver.GetNvCameraToggleStateReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'GetNvCameraToggleState',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetNvCameraToggleState: BridgeCommands.Command<
    Types.Share.Shareserver.SetNvCameraToggleStateParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'SetNvCameraToggleState',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const ToggleAutoHighlight: BridgeCommands.Command<
    Types.Share.Shareserver.ToggleAutoHighlightParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'ToggleAutoHighlight',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const DisableRecordSpecialCase: BridgeCommands.Command<
    Types.Share.Shareserver.DisableRecordSpecialCaseParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'DisableRecordSpecialCase',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetIf4KRecordingFallbackAvailable: BridgeCommands.Command<
    {},
    boolean
    > = {
    legacyCommand: 'QUERY_IS_4K_RECORDING_FALLBACK_AVAILABLE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'GetIf4KRecordingFallbackAvailable',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetExportedGFESettingsData: BridgeCommands.Command<
    {},
    Types.Share.Shareserver.GetExportedGFESettingsDataReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'GetExportedGFESettingsData',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SyncShadowPlaySettings: BridgeCommands.Command<
    Types.Share.Shareserver.SyncShadowPlaySettingsParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'SyncShadowPlaySettings',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const HandleHighlightsGfeConfig: BridgeCommands.Command<
    {},
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'HandleHighlightsGfeConfig',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GAssistToggle: BridgeCommands.Command<
    Types.Share.Shareserver.GAssistToggleParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'ShareServer',
    method: 'GAssistToggle',
    persistent: false
};

export const Shareserver = {
SetCaptureSupported,
RegisterHotkeyNotifications,
RegisterGeneralNotifications,
SetTelemtryInfoToShadowPlay,
RegisterCaptureStateChangeNotifications,
RegisterWindowStateChangeNotifications,
RegisterBroadcastSessionNotifications,
CaptureSavedNotification,
HighlightSavedNotification,
HighlightCaptureFailureNotification,
RegisterSDKNotifications,
RegisterAppNotifications,
GetInitData,
GetMainView,
OpenOsc,
Launch,
SetOverlayReady,
GetShadowPlaySupported,
GetShadowPlayStatus,
Get4KSupport,
GetSupportedBitrates,
GetSupportedBitratesFramerates,
GetSupportedResolutions,
GetSupportedResolutionsCodecs,
GetSupportedFramerates,
GetQualityDefaultData,
GetCaptureState,
GetCaptureProcessInfo,
GetCaptureControlPIDMode,
GetScreenshotSupport,
CaptureScreenshot,
CaptureCustomScreenshot,
CustomScreenshotNotifications,
GetFreestylePreviewBasePath,
StartDiskCapture,
StopAndSaveDiskCapture,
StartBufferedCapture,
StopBufferedCapture,
SaveBufferedCaptureClip,
EDGEEvent,
GetInstantReplayEnableStatus,
GetInstantReplayRunningStatus,
GetInstantReplaySettings,
SetInstantReplaySettings,
EnableInstantReplay,
SaveInstantReplay,
GetLastInstantReplayLength,
GetInstantReplayCustomizeData,
GetRecordEnableStatus,
GetRecordRunningStatus,
EnableRecord,
GetRecordSettings,
SetRecordSettings,
GetRecordCustomizeData,
EnableBroadcast,
PauseBroadcast,
GetBroadcastEnableStatus,
GetBroadcastRunningStatus,
GetBroadcastSupported,
GetBroadcastSettings,
SetBroadcastSettings,
SetBroadcastSession,
GetBroadcastPreferredProviderSetting,
SetBroadcastPreferredProviderSetting,
GetBroadcastLastProvider,
SetBroadcastLastProvider,
GetBroadcastTitle,
GetBroadcast2K,
GetBroadcastFacebookLiveSupport,
GetBroadcastIngestServer,
SetBroadcastIngestServer,
SetBroadcastViewerCountImage,
SetBroadcastViewerMax,
GetRecordBroadcastConcurrencySupport,
GetRecordGamestreamConcurrencySupport,
GetDesktopCaptureEnabled,
SetDesktopCaptureEnabled,
GetDesktopCaptureSupported,
GetDesktopCaptureSupportReason,
GetHevcSupportedState,
GetAudioMode,
SetAudioMode,
GetAudioSettings,
SetAudioSettings,
GetMicCount,
GetMicMode,
SetMicMode,
GetMicSettings,
SetMicSettings,
MicPTTMode,
EnableWebcam,
ToggleWebcam,
GetWebcamEnable,
GetWebcamShown,
GetWebcamPresent,
GetWebcamPreviewState,
EnableWebcamPreview,
GetHighlightsActive,
GetHighlightsEnable,
SetHighlightsEnable,
GetSDKInstanceActive,
GetSDKPermissions,
SetSDKPermissions,
NotifyAppOverlayState,
GetHighlightsConfig,
SetHighlightsConfig,
GetApplicationConfigs,
GetHotkeyShortcut,
SetHotkeyShortcut,
ResetHotkeysToDefault,
GetHotkeyMonitoring,
Init,
SetHotkeyMonitoring,
SetHotkeyDynamicEnable,
GetIndicatorSupported,
GetIndicatorOverlaySettings,
SetIndicatorOverlaySettings,
GetCustomOverlayDefaultPath,
GetCustomOverlaySupport,
GetCustomOverlayPath,
SetCustomOverlayPath,
GetCustomOverlayEnable,
SetCustomOverlayEnable,
GetCustomOverlayDisplay,
SelectCustomOverlay,
EnableCustomOverlay,
GetNvCameraToggleState,
SetNvCameraToggleState,
ToggleAutoHighlight,
DisableRecordSpecialCase,
GetIf4KRecordingFallbackAvailable,
GetExportedGFESettingsData,
SyncShadowPlaySettings,
HandleHighlightsGfeConfig,
GAssistToggle
};
